import React, { useEffect } from "react";
import CreatePagination from "./CreatePagination";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import "./pagination.scss";

const PaginationButtons = ({
  pageSize = 8,
  totalCount = 160,
  siblingCount = 1,
  currentPage,
  setCurrentPage,
  firstPage,
  lastPage,
}) => {
  const pagin = CreatePagination(
    pageSize,
    totalCount,
    siblingCount,
    currentPage
  );

  const onNextClick = () => {
    return currentPage + 1 > Math.ceil(totalCount / pageSize)
      ? setCurrentPage(firstPage)
      : setCurrentPage(currentPage + 1);
  };

  const onPrevClick = () => {
    return currentPage - 1 <= 0
      ? setCurrentPage(lastPage)
      : setCurrentPage(currentPage - 1);
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [currentPage]);

  return (
    <div className="paginsWrapper">
      <li className="pagin decIcon" onClick={() => onPrevClick()}>
        <MdKeyboardArrowLeft />
      </li>
      {pagin.map((num, index) => {
        if (num === "...") {
          return (
            <li
              key={index}
              onClick={() => alert("Use the control icons or numbers")}
              className={`pagin ${currentPage === Number(num) && "activeNum"}`}
            >
              {num}
            </li>
          );
        }
        return (
          <li
            key={index}
            onClick={() => setCurrentPage(Number(num))}
            className={`pagin ${currentPage === Number(num) && "activeNum"}`}
          >
            {num}
          </li>
        );
      })}

      <li className="pagin incIcon" onClick={() => onNextClick()}>
        <MdKeyboardArrowRight />
      </li>
    </div>
  );
};

export default PaginationButtons;
